<template>
  <TitleWrapper
    :title="pluralToSingular(sectionName)"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <SectionCustomName />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <SectionPermission />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <SectionNotification />
  </div>
</template>

<script>
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import SectionNotification from '@src/router/views/settings/notifications/attendance/section/SectionNotificationView.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import SectionPermission from '@src/router/views/settings/system-settings/SectionPermission.vue'
import TitleWrapper from '@components/TitleWrapper.vue'

import UITabs from '@src/components/UiElements/UITabs.vue'
import SectionCustomName from '../../settings/system-settings/SectionCustomName.vue'
import { pluralToSingular } from '@/src/utils/generalUtil'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Settings',
  components: {
    UITabs,
    SectionNotification,
    SectionPermission,
    SectionCustomName,
    TitleWrapper,
  },

  page: {
    title: 'Features Settings',
  },
  data() {
    return {
      FEATURES_TABS,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },

  computed: {
    ...mapState({
      ...mapGetters('featureNaming', ['sectionName']),
    }),
  },

  methods: {
    pluralToSingular,
  },
}
</script>
